import { Permission } from '../permission';
import { ADMINISTRATION_AND_INVOICING } from './administration-and-invoicing';
import { ADMINISTRATORS } from './admins';
import { BASE_DATA } from './base-data';
import { CARE } from './care';
import { EMPLOYEES } from './employees';
import { GENERAL } from './general';
import { GLOBAL_ADMIN } from './global.admin';
import { LISTS } from './lists';
import { RESIDENTS } from './residents';
import { ROSTER } from './roster';

/**
 * Helper function to retrieve all entries of a Rights Configuration Object.
 *
 * @export
 * @param {Object} configurationsObject object containing any arbitrary nested Permissions.
 * @return {string[]} a flattened list of all permission keys within the object provided
 */
export function allValues(configurationsObject: Record<string, unknown>): string[] {
  if (configurationsObject instanceof Permission) {
    return [configurationsObject.key];
  }

  return Object.values(configurationsObject).flatMap((value: unknown) => {
    // if value is a Permission we can return the key immediately
    if (value instanceof Permission) return value.key;

    // otherwise we'll go into recursion with the next layer
    return allValues(value as Record<string, unknown>);
  });
}

/**
 * Configuration Object enumerating all possible Rights structured by categories
 */
export const Rights = Object.freeze({
  RESIDENTS,
  ADMINISTRATION_AND_INVOICING,
  CARE,
  ROSTER,
  LISTS,
  GENERAL,
  BASE_DATA,
  EMPLOYEES,
  GLOBAL_ADMIN,
  ADMINISTRATORS,
});
